<template>
  <modal
    v-if="showModal"
    :show="showModal"
    modal-classes="modal-secondary"
    size="lg"
  >
    <form class="add-form pb-2">
      <div class="form-wrapper">
        <base-input
          type="number"
          :label="`${$t('AUCTIONS.AMOUNT')} (*)`"
          :placeholder="$t('AUCTIONS.AMOUNT')"
          v-model="propertyFee.amount"
        >
        </base-input>
        <validation-error :errors="apiValidationErrors.amount" />
      </div>

      <div class="form-wrapper">
        <base-input
          :label="`${$t('PROPERTIES.DATE_FEE')}`"
          :placeholder="$t('PROPERTIES.DATE_FEE')"
          v-model="propertyFee.date"
          @change="onFormChanged"
        >
          <flat-picker
            :placeholder="$t('PROPERTIES.DATE_FEE')"
            :config="{
              allowInput: true,
              enableTime: false,
              type: 'date',
              minDate: 'today',
              locale: $flatPickrLocale(),
              disable: [
                function (date) {
                  return date.getDay() === 0;
                },
              ],
            }"
            class="form-control datepicker"
            v-model="propertyFee.date"
            @on-change="onFormChanged()"
          >
          </flat-picker>
        </base-input>
        <validation-error :errors="apiValidationErrors.date" />
      </div>

      <div class="form-wrapper full">
        <!-- Excerpt -->
        <base-input
          :label="`${$t('COMMON.EXCERPT')}`"
          :placeholder="$t('COMMON.EXCERPT')"
        >
          <html-editor v-model="propertyFee.description" @change="onFormChanged()">
          </html-editor>
        </base-input>
        <validation-error :errors="apiValidationErrors.description" />
      </div>
    </form>

    <template slot="footer">
      <button
        type="submit"
        class="btn btn-primary"
        @click="submitPropertyFeeForm"
        :disabled="loading"
      >
        <span v-if="loading" class="btn-inner--icon">
          <i class="fas fa-spinner fa-spin"></i>
        </span>
        {{ $t("COMMON.SUBMIT") }}
      </button>

      <button
        type="button"
        class="btn btn-link ml-auto"
        @click="closePropertyFeeModal"
        :disabled="loading"
      >
        {{ $t("COMMON.CLOSE") }}
      </button>
    </template>
  </modal>
</template>

<script>
import { Button } from "element-ui";
import { cloneDeep } from "lodash";
import formMixin from "@/mixins/form-mixin";
import requestErrorMixin from "@/mixins/request-error-mixin";
import ValidationError from "@/components/ValidationError.vue";
import { mapGetters } from "vuex";
import { Option, Select } from "element-ui";
import HtmlEditor from "@/components/Inputs/HtmlEditor";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
  name: "property-fee-form",

  components: {
    ValidationError,
    HtmlEditor,
    [Button.name]: Button,
    [Select.name]: Select,
    [Option.name]: Option,
    flatPicker,
  },

  mixins: [formMixin, requestErrorMixin],

  props: ["property", "propertyFee", "showModal", "loading", "formErrors"],

  data() {
    return {
      lastFee: {},
      showApplyFeeModal: this.showModal,
    };
  },

  computed: {},

  methods: {
    onFormChanged() {
      this.$emit("formChanged");
    },
    closePropertyFeeModal() {
      this.$emit("onClosePropertyFeeModal", true);
    },

    submitPropertyFeeForm() {
      const PropertyFeeData = cloneDeep(this.propertyFee);
      this.$emit("onSubmitPropertyFeeForm", PropertyFeeData);
    },
  },

  mounted() {},

  watch: {

    formErrors(errors) {
      if (errors) {
        this.setApiValidation(errors);
      }
    },
  },
};
</script>
